import { InfoTip } from "@app/ui";
import type { ReactNode } from "react";

import { useI18n } from "../../lib/useI18n.js";

/**
 * A labeled group of settings cards — the middle level between a category page
 * and an individual card. Renders a small heading (with an optional info tip
 * carrying the description) above its children so a page reads as
 * clearly-separated sub-sections.
 */
export function SettingsSection({
  title,
  description,
  children,
}: {
  title: string;
  description?: ReactNode;
  children: ReactNode;
}) {
  const { t } = useI18n();
  return (
    <section className="flex flex-col gap-3">
      <h2 className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        {title}
        {description && <InfoTip label={t("common.moreInfo")}>{description}</InfoTip>}
      </h2>
      {children}
    </section>
  );
}
